import { SelectItem } from '../../../form-definition';
import { useMemo } from 'react';

export const useSelectedItem = (items: SelectItem[], value: string): SelectItem | null => {
  const itemsMap = useMemo(() => new Map(items.map((item) => [item.value, item])), [items]);

  return itemsMap.get(value) ?? null;
};
